/*
JS file for RPNA managed functions on impulse theme 
- light transmission boxes on PDPs
- Variant chane section to inject frame/lens color as well as helmet color via metafields
Referenced in theme.liquid
*/
/*
on variant change functions below.
Triggers should all be aggregated in "theme--ct-modified.js" below line 915
See here for working with json: https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Objects/JSON
*/
function log_variant(variant){
  //console.log(variant);
}

function find_light_icon(ltv){
  var src;

  //logic to determine the icon source
  if(ltv < 7){ //full sun
    src = "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_FullSun.svg?v=1759686419";
  } else if (ltv >7 && ltv < 20){//sun
    src= "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_Sun.svg?v=1759686912";
  } else if (ltv >20 && ltv < 30){//less sun
    src= "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_LessSun.svg?v=1759686419";
  } else if (ltv >30 && ltv < 40){//Partly Cloudy
    src = "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_PartlyCloudy.svg?v=1759686419";
  } else if (ltv > 40 && ltv < 50){//partly sunny
    src = "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_PartlySunny.svg?v=1759686419";
  } else if (ltv > 50 && ltv < 60){//snow
    src = "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_Snow.svg?v=1759686419";
  } else if (ltv > 60){//rain
    src = "https://cdn.shopify.com/s/files/1/2338/3111/files/Rudy_WeatherIcons_Rain.svg?v=1759686419";
  } else {
    src = "not found"
  }
  return src;
}

// function updateStickyHeaderPrice(variant, compare_at_price, actual_price){
//   // first check if there is a sticky header
//   var ct_header_wrapper = document.querySelector(".ct-header-wrapper");
//   if (ct_header_wrapper) {
//     // update price, compare at price and inventory notice.
//     let ca_price = document.querySelector(".ct-header-wrapper [data-compareprice]"),
//     price = document.querySelector(".ct-header-wrapper .money"),
//     inventory_notice = document.querySelector(".ct-header-wrapper p.ct-inventory_notice"),
//     new_inventory_notice_product_form = document.querySelector(".product-block.product-block--sales-point[ct-block-type=\"inventory-status\"] span[data-product-inventory]");

//     if (ca_price) {
//       ca_price.innerText = compare_at_price;
//     }

//     if (inventory_notice) {
//       if (variant.inventory_quantity < 1) {
//         inventory_notice.innerText = "";
//       } else {
//         inventory_notice.innerText = new_inventory_notice_product_form.innerText;
//       }
//     }

//     if (price) {
//       price.innerText = actual_price;
//     }
//   }
// }

/*
code commented out for cranktank's image variant focus feature... rpna requested removal on 5/19/2022
function renderVariantImageFocus(variant){
  //console.log('variant image focus');
  //console.log(variant.sku);
  try{
    ct_process_images(variant.sku);
  } catch (error){
    //console.log(error);
    //console.log('render variant image focus tried, caught. file ct.js')
  }
}
*/

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
Executes IF the product is a sunglass - grabs metadata for variant-button--sunglasses.liquid to use on PDP
*/
function updateFrameLensesBumpers(variant){
  //Determine if you should run the function based on product type
  const ct_data = JSON.parse(document.getElementById("ct-data").textContent);
  let product_type = ct_data['product_type'];
  let frame_lens_titles_binary = ct_data['frame_lens_titles_binary'];
  if( product_type == "sunglass" && frame_lens_titles_binary ){
    //console.log('run function');
    //pull data
    let variant_id = variant['id'];

    //console.log(ct_data);
    let variant_metafields = ct_data['variant_metafields'];
    for(var i = 0; i < variant_metafields.length; i++){
      if(variant_metafields[i]['variant_id'] == variant_id){
        var frame = variant_metafields[i]['sunglass_frame_name'];
        var lenses = variant_metafields[i]['sunglass_lenses_name'];
        var bumper = variant_metafields[i]['sunglass_bumper_name'];
        var light_low = variant_metafields[i]['lens_light_transmission_low'];
        var light_high = variant_metafields[i]['lens_light_transmission_high'];
        break;
      }
    }
    //console.log(frame);
    //console.log(lenses);
    //console.log(bumper);

    //place data
    document.querySelector('span.variant__label-info[ct-variant-metafield="frame"]').innerText = frame+" Frame";
    document.querySelector('span.variant__label-info[ct-variant-metafield="lenses"]').innerText = lenses+ " Lens";
    if(bumper){
      document.querySelector('span.variant__label-info[ct-variant-metafield="bumpers"]').innerText = bumper+" Bumpers";
    }
    if(light_low && light_high){
      //console.log('both lenses');
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      var light_low_icon = find_light_icon(light_low);
      var light_high_icon = find_light_icon(light_high);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').src = light_high_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.remove("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.remove("ct-hidden");
    } else if(light_low){
      //console.log('lens low');
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"%";
      var light_low_icon = find_light_icon(light_low);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.add("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.add("ct-hidden");
    } else {
      //console.log('nadda lens');
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: unset";
    }
  } else {
    //console.log('dont run frame lens bumper function');
  }
}

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
*/
function updateLensDetails(variant){
  //Determine if you should run the function based on product type
  const ct_data = JSON.parse(document.getElementById("ct-data").textContent);
  let product_type = ct_data['product_type'];
  let lens_titles_binary = ct_data['lens_titles_binary'];
  if( product_type == "lenses" && lens_titles_binary ){
    //console.log('update lens values');
    let variant_id = variant['id'];

    //console.log(ct_data);
    let variant_metafields = ct_data['variant_metafields'];
    for(var i = 0; i < variant_metafields.length; i++){
      //find data
      //console.log(variant_id);
      if(variant_metafields[i]['variant_id'] == variant_id){
        var lenses = variant_metafields[i]['sunglass_lenses_name'];
        var light_low = variant_metafields[i]['lens_light_transmission_low'];
        var light_high = variant_metafields[i]['lens_light_transmission_high'];
        break;
      }
    }

    //place data
    document.querySelector('span.variant__label-info[ct-variant-metafield="lenses"]').innerText = lenses;
    if(light_low && light_high){
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"% - "+light_high+"%";
      var light_low_icon = find_light_icon(light_low);
      var light_high_icon = find_light_icon(light_high);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').src = light_high_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.remove("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.remove("ct-hidden");
    } else if(light_low){
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "LTV: "+light_low+"%";
      document.querySelector('span.variant__label-info[ct-variant-metafield="ltv-short"]').innerText = "LTV: "+light_low+"%";
      var light_low_icon = find_light_icon(light_low);
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.low-range').src = light_low_icon;
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] img.high-range').classList.add("ct-hidden");
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission-icons"] span.ct-icon-dash').classList.add("ct-hidden");
    } else {
      document.querySelector('span.variant__label-info[ct-variant-metafield="light-transmission"]').innerText = "";
    }

  } else {
    //console.log('do nothing');
  }
}

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
Brian added 10/5/2025 to surface and display the variant SKU on the PDP in the product form
*/
function updateVariantSKU(variant){
  if (!variant || !variant.sku) return;

  // Try to find where SKU should appear
  // Example selectors — adjust based on your product template
  const skuElements = document.querySelectorAll('[data-product-sku], .product-sku, span.variant__sku');

  skuElements.forEach(el => {
    el.innerText = variant.sku;
  });
}

/*
Runs on product variant change (called from line 915 or so in theme--ct-modified.js)
*/
function updateHelmetColor(variant){
  //Determine if you should run the function based on product type
  const ct_data = JSON.parse(document.getElementById("ct-data").textContent);
  let product_type = ct_data['product_type'];
  let helmet_color_title_replacement_binary = ct_data['helmet_color_title_replacement'];
  if(product_type == "helmet" && helmet_color_title_replacement_binary ){
    //if product type == helmets and if the user checked the box off, then run function
    //console.log('execute function');
    let variant_id = variant['id'];
    let variant_metafields = ct_data['variant_metafields'];

    //pull variant data when found.
    for(var i = 0; i < variant_metafields.length; i++){
      if(variant_metafields[i]['variant_id'] == variant_id) {
        var helmet_color = variant_metafields[i]['helmet_color'];
        break;
      }
    }

    //place data
    document.querySelector('div.variant-wrapper label.variant__label span.variant__label-info span').innerText = helmet_color;

  } else {
    //else, don't run the function
    //console.log('dont update helmet color');
  }
}

/*
display ltv box
*/
function displayLtvBox(){
  //pull data
  var smallArrow = document.querySelector("span.ct-variant-learn-more svg");
  var wrapper = document.querySelector("span.ct-variant__label-wrapper[ct-status]");
  //change classes, etc
  if(wrapper.getAttribute("ct-status") == "collapsed"){
    smallArrow.classList.add("rotated");
    wrapper.setAttribute("ct-status","visible");
  } else {
    smallArrow.classList.remove("rotated");
    wrapper.setAttribute("ct-status","collapsed");
  }
}

/*display accordion boxes on bold*/
function ctAccordionNew(variable){
  var carrot = variable.querySelector(".down-carot-wrapper");
  var panel = variable.querySelector("div.accordion-panel");
  var classList = panel.classList;
  var proceed = true;
  for (var i = 0; i < classList.length; i++){
    if ( classList[i] == 'accordion-hidden' ){
      proceed = false;
      break;
    }
  }
  //console.log(proceed);
  if(proceed){
    //panel.setAttribute("style","");
    panel.classList.remove("accordion-open");
    panel.classList.add("accordion-hidden");
    carrot.classList.add("new-open");
    carrot.classList.remove("new-closed");
  } else {
    panel.classList.add("accordion-open");
    panel.classList.remove("accordion-hidden");
    carrot.classList.remove("new-open");
    carrot.classList.add("new-closed");
  }
}
function ctAccordion(variable){
  var carrot = variable.querySelector(".down-carot-wrapper");
  var panel = variable.parentElement.children[1];
  var classList = panel.classList;
  var proceed = true;
  for (var i = 0; i < classList.length; i++){
    if ( classList[i] == 'open' ){
      proceed = false;
      break;
    }
  }
  if(proceed){
    panel.setAttribute("style","");
    panel.classList.add("open");
    carrot.classList.add("open");
  } else {
    panel.classList.remove("open");
    carrot.classList.remove("open");
  }
}

/*
Render variant lens details metaobject dynamically on variant change
Brian added 10/6/2025 to surface and display the variant lens detail metaobject on the PDP
Data built up in ct-variant-data--sunglasses.liquid & ct-variant-data--lenses.liquid
Listner added to theme--ct-modified.js - line 923
Varian Lens Details section added to each sunglass theme page
*/
function updateVariantLensDetails(variant){
  try {
    if (!variant) return;

    const ct_data_el = document.getElementById("ct-data");
    if (!ct_data_el) return;

    const ct_data = JSON.parse(ct_data_el.textContent);
    const variant_id = Number(variant.id);
    const variant_metafields = ct_data['variant_metafields'] || [];

    // Find matching variant entry (if any)
    const meta = variant_metafields.find(v => Number(v.variant_id) === variant_id);

    // Prefer per-variant metaobject; fall back to product-level metaobject
    let details = meta && meta.variant_lens_details ? meta.variant_lens_details : null;
    if (!details && ct_data.product_lens_details) {
      details = ct_data.product_lens_details;
    }
    if (!details) {
      console.warn("No lens details metaobject at variant OR product level for variant:", variant_id);
      return;
    }

    const container = document.querySelector('[data-lens-details]');
    if (!container) {
      console.warn("Lens details container not found");
      return;
    }

    // Build weather condition gallery (icons + labels)
    let weatherMarkup = '';
    if (Array.isArray(details.weather_conditions) && details.weather_conditions.length) {
      const items = details.weather_conditions
        .filter(o => o && (o.image || o.label))
        .map(o => {
          const img = o.image ? `<img class="lens-weather__img" src="${o.image}" alt="${o.label || 'Condition'}">` : '';
          const label = o.label ? `<span class="lens-weather__label">${o.label}</span>` : '';
          return `<div class="lens-weather__item">${img}${label}</div>`;
        })
        .join('');
      weatherMarkup = `
        <div class="lens-weather">
          <!-- <div class="lens-weather__title">Best For</div> -->
          <div class="lens-weather__grid">${items}</div>
        </div>
      `;
    }

    // Build core details
    const low = details.low_light_transmission || "";
    const high = details.high_light_transmission || "";
    const range = (low && high) ? `${low} - ${high}` : (low || high || "");

    container.innerHTML = `
      <div class="lens-details-container">
        <div class="lens-details-row lens-details-row-1">
          <div class="lens-details-col lens-details-col-1">
            ${details.lens_technology_swatch ? `<img src="${details.lens_technology_swatch}" alt="${details.lens_name || 'Lens'} swatch">` : ""}
          </div>
          <div class="lens-details-col lens-details-col-2">
            <h1 class="h2">${details.lens_name || ""}</h1>
            ${range ? `<div class="lens-stats"><p class="ltv-range"><strong>Light Transmission:</strong> ${range}%</p></div>` : ""}
            ${details.filter_category ? `<div class="lens-description"><p><strong>Filter Category:</strong> ${details.filter_category}</p></div>` : ""}
            ${details.base_tint_color ? `<div class="lens-description"><p><strong>Base Tint:</strong> ${details.base_tint_color}</p></div>` : ""}
            ${details.mirror ? `<div class="lens-description"><p><strong>Front Mirror:</strong> ${details.mirror}</p></div>` : ""}
            ${details.uv_protection ? `<div class="lens-description"><p><strong>UV Protection:</strong> ${details.uv_protection}</p></div>` : ""}
            ${details.lens_type ? `<div class="lens-description"><p><strong>Lens Type:</strong> ${details.lens_type}</p></div>` : ""}
            <div class="lens-description"><p>&nbsp;</p></div>
            ${details.lens_technology_description ? `<div class="lens-description"><p>${details.lens_technology_description}</p></div>` : ""}
            <div class="lens-description"><p>&nbsp;</p></div>
            ${details.lens_technology_best_for ? `<!-- <div class="lens-best-for"><p><strong>Best For:</strong> ${details.lens_technology_best_for}</p></div> -->` : ""}
            ${weatherMarkup}
          </div>
        </div>
      </div>
    `;
  } catch (err) {
    console.error("updateVariantLensDetails error:", err);
  }
}
// -------------------------------
// Robust "current variant id" resolver (ignores hidden/remodal forms)
// used in the variant lens details section on sunglass product theme pages
// -------------------------------
function isVisibleDeep(el) {
  if (!el) return false;
  let node = el;
  while (node && node.nodeType === 1) {
    const cs = getComputedStyle(node);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    if (node.hasAttribute('hidden') || node.getAttribute('aria-hidden') === 'true') return false;
    if (node.classList.contains('hidden') || node.classList.contains('ct-hidden') || node.classList.contains('remodal') || node.classList.contains('modal')) return false;
    node = node.parentElement;
  }
  return true;
}

function getCtData() {
  const el = document.getElementById('ct-data');
  if (!el) return null;
  try { return JSON.parse(el.textContent); } catch { return null; }
}

function getVisibleCurrentVariantId() {
  const ct = getCtData();
  const validIds = new Set((ct?.variant_metafields || []).map(v => String(v.variant_id)));

  // 1) visible <input name="id"> that maps to a valid variant in ct_data
  const inputs = Array.from(document.querySelectorAll('input[name="id"]'));
  const vis = inputs.filter(i => isVisibleDeep(i) && validIds.has(String(i.value)));
  if (vis.length) return parseInt(vis[0].value, 10);

  // 2) fallback: any input that maps to ct_data (even if “visible” heuristics failed)
  const mapped = inputs.find(i => validIds.has(String(i.value)));
  if (mapped) return parseInt(mapped.value, 10);

  // 3) final fallback: ct_data’s selected_or_first_available_id
  if (ct?.selected_or_first_available_id) return parseInt(ct.selected_or_first_available_id, 10);

  return null;
}

// -------------------------------
// Initialize + keep in sync
// -------------------------------
(function initLensDetailsBoot() {
  let didInitialRender = false;

  function tryRender() {
    if (didInitialRender) return true;
    const container = document.querySelector('[data-lens-details]');
    const id = getVisibleCurrentVariantId();
    if (container && id) {
      updateVariantLensDetails({ id });
      didInitialRender = true;
      return true;
    }
    return false;
  }

  function kick() {
    if (tryRender()) return;
    // Retry briefly in case Impulse injects things after ready
    let tries = 0, max = 40; // ~2s
    const t = setInterval(() => {
      tries++;
      if (tryRender() || tries >= max) clearInterval(t);
    }, 50);
  }

  // cover all lifecycle cases
  document.addEventListener('DOMContentLoaded', kick);
  window.addEventListener('load', kick);
  document.addEventListener('page:loaded', kick);
  document.addEventListener('shopify:section:load', kick);
  document.addEventListener('shopify:section:select', kick);

  // keep updating on variant changes
  document.addEventListener('variant:change', (e) => {
    if (e.detail?.variant) {
      updateVariantLensDetails(e.detail.variant);
    } else {
      const id = getVisibleCurrentVariantId();
      if (id) updateVariantLensDetails({ id });
    }
  });
})();

//ALL FUNCTIONS BELOW THIS LINE WERE ORIGINALLY IN THE ctjs.js SCRIPT
//I COMBINED THEM INTO ct.js AND REMOVED THE REFERENCE TO THAT ctjs.js SCRIPT
//IN THE THEMES MAIN LIQUID FILE

//Custom RPNA functions

/*
onclick function to expand and contract an accordion
*/
function ctAccordion(title){
  var panel = title.nextElementSibling;
  var carot = title.childNodes[3].childNodes[1];
  if (panel.style.height === "0px"){
    panel.style.height = "auto";
    panel.style.padding = "12px 18px";
    panel.style.borderLeft = "1px solid #e5e5e6";
    panel.style.borderRight = "1px solid #e5e5e6";
    panel.style.borderBottom = "1px solid #e5e5e6";
    carot.style.transform = "scale(-1)";
  } else {
    panel.style.height = "0px";
    panel.style.padding = "0px";
    panel.style.border = "none";
    carot.style.transform = "scale(1)";
  }
}


function removeSaleTag(){
  //console.log('sale tag removed');
  let gridItemsToRemove = document.getElementsByClassName('ct-remove-sale-hook');
  let x = 0;
  do{
    gridItemsToRemove[x].parentElement.parentElement.parentElement.classList.add('not-on-sale');
    x++;
  } while( x < gridItemsToRemove.length);
}

/*
new onclick function with css animation
*/
function ctAccordionNew(title){
  var children = title.childNodes;
  var body;
  var x = 0;
  //loop to find the body child
  do{
    if (children[x].className == "accordion-panel accordion-hidden" || children[x].className == "accordion-panel accordion-expanded"){
      body = children[x];
      break;
    }
    x++;
  } while (x < children.length);

  //loop to find the carot
  var carot = "blank";
  x = 0;
  do{
    if (children[x].tagName == "SMALL"){
      carot = children[x].childNodes[1].childNodes[3].childNodes[1];
      console.log(carot);
      break;
    }
    x++;
  } while (x < children.length);

  if (carot == "blank"){
    carot = title.childNodes[1].childNodes[3].childNodes[1];
  }

  //change the class name based on the info provided
  if (body.className == "accordion-panel accordion-hidden"){
    body.className = "accordion-panel accordion-expanded";
    carot.style.transform = "scale(-1)";
  } else {
    body.className = "accordion-panel accordion-hidden";
    carot.style.transform = "scale(1)";
  }


  /*
  //Old code... worked for shorter divs??
  var panel = title.nextElementSibling;
  var carot = title.childNodes[3].childNodes[1];
  console.log("title: "+title);
  console.log("panel: "+panel);
  console.log("carot: "+carot);
  if (panel.className == "accordion-panel accordion-hidden"){
    panel.className = "accordion-panel accordion-expanded";
    carot.style.transform = "scale(-1)";
  } else {
    panel.className = "accordion-panel accordion-hidden";
    carot.style.transform = "scale(1)";
  }
  */
}

/*
New change price function
Needs to account for logic change to theme.

BRO / LEADER IS BROKEN ON OUTLET PRODUCTS.


*/
function changePrice2(discountMult, sectionId, discountTag, compareAtPriceVaries){
  let saleTheme = true;
  console.log('change price triggered');
  console.log('discount Mult'+discountMult);
  console.log('section ID'+sectionId);
  console.log('discount tag'+discountTag);
  console.log('ca price varies'+compareAtPriceVaries);
  //if the product's compareAtPriceVaries, then we have to treat the logic slightly differently.
  //If that's the case, then run the "compareAtPriceVaries" variation below
  //figure out if this is a gift card, and if it is, then skip ALL Logic
  let title = document.querySelector("h1.product-single__title");
  //console.log(title.innerText);
  if (title.innerText == "RUDY PROJECT DIGITAL GIFT CARD"){
  //console.log('skip');
  } else {
  //console.log('dont skip');

    if(compareAtPriceVaries){

      //if the discount Tag is within our range
      if(discountTag == 'bro' || discountTag == 'vip' || discountTag == 'pr0m0tive' || discountTag == 'usat' || discountTag == 'normCore'){
        setTimeout(function(){
          //console.log('compare at price varies and bro');
          //pull the compare price, product price and discount price from the html block.
          var compareAtPrice = document.getElementById('ComparePrice-'+sectionId).children[1].innerHTML;
          compareAtPrice = Number(compareAtPrice.replace(/[^0-9\.]+/g,""));
          //console.log('compare at price: '+compareAtPrice);
          var productPrice = document.getElementById('ProductPrice-'+sectionId).innerHTML;
          productPrice = Number(productPrice.replace(/[^0-9\.]+/g,""));
          //must pull the "content" attribute from the pricing div. This is for comparison. If the content is the same as the data-currency-usd attribute, do nothing.
          var contentAtt = document.getElementById('ProductPrice-'+sectionId).getAttribute("content");
          contentAtt = Number(contentAtt.replace(/[^0-9\.]+/g,""));


          if(productPrice == contentAtt){
            //console.log('nothing... product price equals content att');
          } else {

            //Set variables for price and compare at price based on new variant
            var price = (productPrice * discountMult);
            var comparePrice = compareAtPrice;
            price = (Math.round(price * 1000) / 1000).toFixed(2);

            //logic to correct comparePrice if required
            //this case comes up during non sale themes on tagged users for products that have variable compare at prices.


            var compareDiscountPercent = ((comparePrice - price) / comparePrice)*100;
            compareDiscountPercent = compareDiscountPercent.toFixed(0);
            console.log('ca_discount_percent: '+compareDiscountPercent);

            // must first ignore this logic entirely if the product is an outlet product
            var outletBinary = document.querySelector('.ct-hidden.ct-discount-tag[key="outletBinary"]');
            var producttitlevar = document.querySelector(".product-title h1").innerText;
            console.log(producttitlevar);
            //console.log('ob: ');
            //console.log(outletBinary);

            switch (producttitlevar) {
              case "CUTLINE":
                outletBinary = false;
                break;
              case "TRALYX+ SLIM":
                outletBinary = false;
                break;
              case "TRALYX+":
                outletBinary = false;
                break;
              case "DEFENDER":
                outletBinary = false;
                break;
              case "OVERLAP":
                outletBinary = false;
                break;
              case "SPINAIR 56":
                outletBinary = false;
                break;
              case "SPINAIR 57":
                outletBinary = false;
                break;
              case "SPINHAWK":
                outletBinary = false;
                break;
              default:
                console.log("nothing");
            }

            if (outletBinary){
              //console.log('outlet product');

            } else {
              //console.log('not an outlet product, so execute discount percent fix');
              if(compareDiscountPercent != (1-discountMult)*100){
                //console.log('need to change percent');
                comparePrice = (price/(discountMult)).toFixed(0);
                comparePrice = comparePrice - .01;
              } else {
                //console.log('Youre good.');
              }
            }



            var discount_tag = document.querySelector('span.ct-hidden.ct-discount-tag[key=\"discountTag\"]');
            discount_tag = discount_tag.getAttribute('value');
            var product_type = document.querySelector('span.ct-hidden.ct-discount-tag[key=\"product_type\"]');
            if(product_type){
              product_type = product_type.getAttribute('value');
            }
            //console.log(discount_tag);
            //console.log(product_type);

            if(saleTheme){
              console.log('ca price: '+compareAtPrice);
              var comparePrice = compareAtPrice;
              var compareDiscountPercent = ((comparePrice - price) / comparePrice)*100;
              compareDiscountPercent = compareDiscountPercent.toFixed(0);
            }

            //console.log('compare discount percent: '+compareDiscountPercent);
            //console.log('comparePrice: '+comparePrice);
            //console.log('price: '+price);

            //put variables in play / display for the client
            document.getElementById('ProductPrice-'+sectionId).innerHTML = "$"+price;
            document.getElementById('ProductPrice-'+sectionId).setAttribute("content", price);
            document.getElementById('ComparePrice-'+sectionId).children[1].innerHTML = "$"+comparePrice;
            document.getElementById('ComparePrice-'+sectionId).style.display = "inline-block";
          }
        }, 0);
      } else {
        //do nothing
      }

    //If the compare at price does not vary from the product price, then we have a different logic block.

    } else {
      if(discountTag == 'bro' || discountTag == 'vip' || discountTag == 'pr0m0tive' || discountTag == 'usat' || discountTag == 'normCore'){ //if the user has a discount tag in our range
        let starterVariant = document.querySelector('.variant-wrapper .variant__label').innerHTML;
        let starterFullPrice = document.getElementById('ProductPrice-'+sectionId).innerHTML;
        document.getElementById('ProductPrice-'+sectionId).setAttribute('ct-discount-price-flag', 'unset');
        setTimeout(function(){ // need to set timeout for the current page to load the original html before this function runs
          //pull price
          let contentAtt = document.getElementById('ProductPrice-'+sectionId).getAttribute('content');
          let variant = document.querySelector('.variant-wrapper .variant__label').innerHTML;
          let fullPrice = document.getElementById('ProductPrice-'+sectionId).innerHTML;
          fullPrice = Number(fullPrice.replace(/[^0-9\.]+/g,""));
          let discountPrice = (fullPrice*discountMult).toFixed(2);
          let discountComparePrice = (fullPrice/discountMult).toFixed(2);
          let starterFullPriceAdjusted = Number(starterFullPrice.replace(/[^0-9\.]/g,""));
          let originalPrice = (starterFullPriceAdjusted/discountMult).toFixed(2);
          //console.log('starterVariant: '+starterVariant);
          //console.log('starter: '+starterFullPrice);
          //console.log('full: '+fullPrice);
          //console.log('discount: '+discountPrice);

          let compareVisibility = document.getElementById('ComparePrice-'+sectionId).style.display;

          if(starterVariant == variant){
            //console.log('logic 1');
            //do nothing
          } else if (starterFullPrice == "$"+fullPrice){

            if(compareVisibility == 'inline-block'){
              //console.log('logic 2.1');
              document.getElementById('ProductPrice-'+sectionId).innerHTML = "$"+fullPrice;
              document.getElementById('ComparePrice-'+sectionId).innerHTML = "$"+discountComparePrice;
              document.getElementById('ComparePrice-'+sectionId).style.display = 'inline-block';
              document.getElementById('ComparePrice-'+sectionId).style.textDecoration = 'line-through';
              document.getElementById('ProductPrice-'+sectionId).setAttribute('last-clicked',variant);
            } else {
              //console.log('logic 2.2');
              document.getElementById('ProductPrice-'+sectionId).innerHTML = "$"+discountPrice;
              document.getElementById('ComparePrice-'+sectionId).innerHTML = "$"+fullPrice;
              document.getElementById('ComparePrice-'+sectionId).style.display = 'inline-block';
              document.getElementById('ComparePrice-'+sectionId).style.textDecoration = 'line-through';
              document.getElementById('ProductPrice-'+sectionId).setAttribute('last-clicked',variant);
            }
          } else {
            //console.log('logic 3');
            document.getElementById('ProductPrice-'+sectionId).innerHTML = "$"+discountPrice;
            document.getElementById('ComparePrice-'+sectionId).innerHTML = "$"+fullPrice;
            document.getElementById('ComparePrice-'+sectionId).style.display = 'inline-block';
            document.getElementById('ComparePrice-'+sectionId).style.textDecoration = 'line-through';
            document.getElementById('ProductPrice-'+sectionId).setAttribute('last-clicked',variant);
          }
        }, 0);
      } else {
        //do nothing
      }
    }
  }
}


/*
function to change the price on the bold product options pages.
These have much different layouts than the normal product page, so needs a different formula to rip through and change prices.
*/
function changeBoldPrice(discountMult, discountTag){ //test code  changeBoldPrice(.8, 'vip');
  if(discountTag == 'bro' || discountTag == 'vip' || discountTag == 'pr0m0tive' || discountTag == 'usat'){ //if the user has a discount tag in our range
    //need to run code off of the following elements...
    var boldTitles = document.getElementsByClassName('bold_option_swatch_title');

    //loop through the boldTitles
    //if the bold title has an inner element with class "ct-discount-money", then it's already been discounted... stop
    //If the bold title has an inner element with class "money", then continue...
    //Discount "money" appropriately and add a slashed out price beneath it for the original with class = "ct-discount-money"


  }
}

/*kindof works, but not fully*/
function changeBoldPriceonepointohhh(discountMult, discountTag){ //test code  changeBoldPrice(.8, 'vip');
  if(discountTag == 'bro' || discountTag == 'vip' || discountTag == 'pr0m0tive' || discountTag == 'usat'){ //if the user has a discount tag in our range
    var moneyElements = document.getElementsByClassName('money');
    var priceHTMLElements = document.getElementsByClassName('bold_option_value_price');
    var i = 0;
    var innerText, outerPriceHTML, priceDiscounted; //setting critical variables for functions below.

    //troubleshooting variables
    var changed = 0;//troubleshooting variables
    var discountSkippedAlreadySet = 0;//troubleshooting variables
    var skipped = 0; //troubleshooting variables
    //console.log(priceHTMLElements);

    //loop through all moneyElements and change the ones that need changing.
    do {

      innerText = Number(moneyElements[i].innerText.replace(/[^0-9\.]+/g,""));
      outerPriceHTML = priceHTMLElements[i];

      if (innerText){
        //in this case, we can discount since the price has not yet been discounted and we have a tagged user.
        priceDiscounted = (innerText * discountMult);
        priceDiscounted = Math.round(priceDiscounted * 100) / 100;

        //Replace the discounted price value
        moneyElements[i].innerHTML = "$"+priceDiscounted+" USD";
        priceHTMLElements[i].innerHTML += "<br><span>$"+ innerText +" USD</span>";

        changed++; //troubleshooting var

      } else {
        //do nothing as of now
        skipped++;//troubleshooting var
      }
      i++;
    } while (i < moneyElements.length);

  } else {
    //do nothing
  }
}


/*
 function to display product side images based on a variant id (if the images exist)
 associated variant id is added as an onclick function to the appropriate label. This was added to "swatch.liquid" file in snippits.
 variant id is generated programatically in a google sheet here: https://docs.google.com/spreadsheets/d/1fvPtKF3naHH3Qw1RDzVqbKTLzIktIGtsuVKHeT4kah4/edit#gid=431512001
 if you don't have access to google sheet, ask for permission from Taylor
*/
function ctImgSwitch(variantId, discountMult, sectionId, discountTag, compareAtPriceVaries){
  //console.log('ct img switch triggered');
  var ctImgContainers = document.getElementsByClassName('ct-side-img-container');
  var ctDisplayContainer = document.getElementById(variantId);
  var n = 0;
  if(ctImgContainers.length == 0 || ctImgContainers.length == 1){
    //do nothing
    //console.log("no image containers");
  } else {
    do{
      ctImgContainers[n].style.display = "none";
      n++;
    } while(n<ctImgContainers.length);
  }

  if(ctDisplayContainer){
    ctDisplayContainer.style.display = "block"; //occasional error that cannot display
  }

  //call the change price function which changes the price on the fly
  if (discountMult == 1 || discountMult == false){
    //don't run (i.e., the price doesn't need to change).
  } else {
    changePrice2(discountMult, sectionId, discountTag, compareAtPriceVaries);
  }

  let button = document.querySelector('div.button-wrapper.default-cart-button');
  button.classList.remove("ct-hidden");
  updateQuadpayPrice(sectionId); //Update the quadpay price on product variant switch.
  updateDiscountPercent(sectionId, discountMult); //update the discount percent
  inventoryAlert(); //Update inventory alert on inventory switch.
}

/*run all listener functions*/
function ctProductListeners(discountMult, sectionId, discountTag, compareAtPriceVaries){
  // displayFirstVar();
  console.log('run new function');
  changePrice2(discountMult, sectionId, discountTag, compareAtPriceVaries);
  // featuredImgHeightTransfer();
  window.addEventListener("resize", featuredImgHeightTransfer);
  //console.log("ct product listeners: "+compareAtPriceVaries);
  //decomissioned invocations
  //ctVariantListenerAdderWaiting();
  //ctImgListener();
}

/*
DISPLAY FIRST VAR
it runs through the list of image swatch divs on a product page.
It then finds the first one on a given view (aka, the one that will be selected for the image side displayer).
it then displayes the div associated with it
*/
function displayFirstVar(){
  setTimeout(function(){
    var swatchesArray = document.getElementsByClassName('swatch-container color square');
    var n = 0;
    do{
      var itemClass = swatchesArray[n].getAttribute('class');
      if (itemClass == 'swatch-container color square soldout'){
        //do nothing
      } else {
        var child = swatchesArray[n].getElementsByClassName('single-option-selector__radio single-option-selector-image-product-template');
        var returnId = child[0].getAttribute('value');
        break;
      }
      n++;
    } while (n < swatchesArray.length);
    ctImgSwitch(returnId, false,'false','false');
  }, 1);
}


/*Finds the current variant url
function ctVariantIdFinder(){
  var variantId = new URLSearchParams(document.location.search.substring(1)).get("variant");
  //console.log(variantId);
}*/

/*find the height of the featured image div and set taylor's image divs to the same height*/
function featuredImgHeightTransfer(){
  /*first set the image size based on the loaded browser...*/
  var featuredImg = document.getElementById('ProductPhoto-image-product-template');
  /*console.log(featuredImg.offsetHeight);*/

  var ctImages = document.getElementsByClassName('ct-featured-image-aside');
  var x = 0;
  do {
    ctImages[x].style.height = featuredImg.offsetHeight+"px";
    ctImages[x].style.width = featuredImg.offsetWidth+"px";

    x++;
  } while (x < ctImages.length);
}

/*
the quadpay app doesn't have a recalculation function after page load.
Need to inject a recalculation for the page if a variant has a different price from another.
*/
function updateQuadpayPrice(sectionId){
  setTimeout( function(){
    var variantPriceElement = document.getElementById('ProductPrice-'+sectionId);
    var variantPrice = variantPriceElement.innerHTML.match(/[0-9.]/g).join('');
    var quadpayPrice = Math.ceil((variantPrice*100)/4);
    quadpayPrice = (quadpayPrice/100).toFixed(2); //quadpay price successfully taken.

    //find the span that you need to replace. Pain in the ass since they didn't put ID's on anything.
    var priceParentElement = document.getElementsByClassName('selection-wrapper price product-single__price-'+sectionId)[0];
    //console.log('sectionID: '+sectionId);
    var quadpayElement = priceParentElement.lastElementChild.lastElementChild.lastElementChild;

    //set the correct price after variant change
    //quadpayElement.innerHTML = "$"+quadpayPrice;
  },0);

}

/*
fixing a bug where the percentage off doesn't change after a user tinkers with variants
*/
function updateDiscountPercent(sectionId, discountMult){
  setTimeout( function(){
    var variantPriceElement = document.getElementById('ProductPrice-'+sectionId);
    var price = variantPriceElement.innerHTML.match(/[0-9.]/g).join('');
    price = price*1000;
    try{
      //finding the compare at price (which changes during the page interactions)
      var variantComparePriceElement = document.getElementById('ComparePrice-'+sectionId);
      var tryPrice = variantComparePriceElement.innerHTML.match(/[0-9.]/g).join('');
      if (tryPrice > 0){
        //console.log('try price worked');
      } else{
        //console.log('try price didnt work');
        var variantComparePriceElement = document.getElementById('ComparePrice-'+sectionId).lastElementChild;
      }
      var comparePrice = variantComparePriceElement.innerHTML.match(/[0-9.]/g).join('');
      comparePrice = comparePrice*1000;
    } catch(e){
      //console.log(e);
    }
    /*
    console.log(price);
    console.log(comparePrice);
    console.log('dmult: '+discountMult);
    */

    let percentageOff = (1 - (price/comparePrice) ).toFixed(4);
    percentageOff = percentageOff * 100;
    //console.log('1: '+percentageOff);

    if( discountMult < 1){
      let percentageOff = ((1-discountMult)*100).toFixed(2);
      //console.log('2: '+percentageOff);
      //console.log(percentageOff);
    }

    if(percentageOff <= 0){
      document.getElementsByClassName('discount-notifier product-form')[0].style.display = "none";
      //console.log('removed');
    } else if (percentageOff > 0){
      //console.log('3: '+percentageOff);
      var percentageOffElement = document.getElementsByClassName('discount-notifier product-form')[0];
      percentageOffElement.innerHTML = "You Save "+percentageOff.toFixed(0)+"%";
      percentageOffElement.style.display = "inline-block";
      //console.log('updated amount');
    } else {
      //console.log('nothing');
    }
  }, 0);
}


//
function updateOutletPercent(sectionId){
  setTimeout(function(){
    var price = document.getElementById('ProductPrice-'+sectionId).innerHTML.match(/[0-9.]/g).join('');
    var comparePrice = document.querySelector('#ComparePrice-'+sectionId+' span.money').innerHTML.match(/[0-9.]/g).join('');
    console.log(price);
    console.log(comparePrice);
    //do some Math
    var percentageOff = ((1 - (price/comparePrice))*100).toFixed(0);
    let percentStatement = "You Save "+percentageOff+"%";

    //find the right element to swap out our statement with.
    document.querySelector('#AddToCartForm-'+sectionId+' span.discount-notifier.product-form').innerHTML = percentStatement;
  }, 100);
}

/*
  On product form change, this function searches html for "inventory alerts"
  If the script finds an inventory alert for a variant in question, it...
  	1) adds text right above the add-to-cart button for appropriate alerts (low inventory, or backorder).
    2) if the item is in backorder, it changes the button text to "Backorder" rather than "add to cart"
*/


function inventoryAlert(){
  var inventoryAlerts = document.getElementsByClassName('ct-inventory-alert');
  var inventoryHook = document.querySelector("#ct-inventory-hook span.ct-inv-title");

  //pull current variant and the inventory alert message for that variant.
  setTimeout(function(){
    //store the variant from the url string in vars.variant
    try{
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
      });
      var variantId = vars.variant+'-inventory-message';
      var currentVarAlert = document.getElementById(variantId); //variantId as defined in the html in product-form.liquid
      var alertMessage = currentVarAlert.children[0].innerHTML;
      //console.log(alertMessage);
      //console.log(currentVarAlert);
      inventoryHook.innerHTML = currentVarAlert.innerHTML;
    } catch(e) {
      //console.log(e);
      //inventoryHook.innerHTML = inventoryAlerts[0].innerText; -- the hack referenced below.
      //if this errors out, it's because there isn't a "variant" in the url. Pull the selected-or-first-available out of the html and use that instead of the hack.
      let selected_or_first_sku = inventoryAlerts[0].getAttribute("selected-or-first-available-sku");
      let selected_or_first_inv_alert = document.querySelector('.ct-inventory-alert[data-sku="'+selected_or_first_sku+'"]').innerHTML;
      inventoryHook.innerHTML = selected_or_first_inv_alert;
    }

    var i = 0;
    do{
      inventoryAlerts[i].style.display = "none";
      i++;
    } while(i < inventoryAlerts.length)
  }, 10);

}

/*
  Adds text transitions on the UTMB landing page
  	https://www.rudyprojectna.com/pages/rudy-project-the-official-eyewear-of-the-utmb-world-series
*/

  const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, {
  threshold: 0.2 // triggers when 20% is visible
});

document.querySelectorAll('.animate-on-scroll').forEach(el => {
  observer.observe(el);
});